var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonitoringIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 21.4,
    width: 9.6,
    height: 32.4,
    rx: 1.8,
    stroke: "white",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7001,
    y: 43.4,
    width: 5,
    height: 8,
    rx: 0.816767,
    fill: "#3FA60F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.8,
    y: 21.4,
    width: 9.6,
    height: 32.4,
    rx: 1.8,
    stroke: "white",
    strokeWidth: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27.2,
    y: 46.4,
    width: 5,
    height: 5,
    rx: 0.816767,
    fill: "#3FA60F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 39.2,
    y: 21.4,
    width: 9.6,
    height: 32.4,
    rx: 1.8,
    stroke: "white",
    strokeWidth: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 41.5001,
    y: 27.4,
    width: 5,
    height: 24,
    rx: 0.816767,
    fill: "#FF3D00"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 53.6,
    y: 21.4,
    width: 9.6,
    height: 32.4,
    rx: 1.8,
    stroke: "white",
    strokeWidth: 3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 55.9,
    y: 36.4,
    width: 5,
    height: 15,
    rx: 0.816767,
    fill: "#FFB800"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoringIcon);
export default __webpack_public_path__ + "static/media/MonitoringIcon.60638f1e3caeaa0b6af360c7d5a7c906.svg";
export { ForwardRef as ReactComponent };